import axios            from "@/axios/axios";
import createDictionary from "@/helpers/createDictionary";

export default createDictionary({
  loadData:          () => axios.get('devices_type'),
  // transformResponse: ( list ) => {
  //   list.forEach(item => {
  //     item.color = colors[item.id] || defaultColor;
  //     item.icon = icons[item.id] || defaultIcon;
  //   });
  //   return list;
  // },
});
